export type Group = {
  id: string
  parent_id: string | null
  name: string
  depth: number
  path: string
  product_count: number
  is_leaf: boolean
}
export type TreeProps = { groups: Group[]; unassigned_count: number }
export type ProductRow = { id: string; external_id: string; name: string; sku: string | null; sold_12m: number }

// Stands for "products with no group" in the group picker and in requests.
export const UNASSIGNED = 'unassigned'

function csrfToken(): string {
  return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content ?? ''
}

// Sends JSON to Rails. A failed request returns the server's error sentences
// instead of throwing, so the page can show them in red.
export async function sendJson<T>(
  url: string,
  method: 'POST' | 'PATCH' | 'DELETE',
  body?: unknown,
): Promise<{ ok: boolean; data: T | null; errors: string[] }> {
  try {
    const res = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrfToken() },
      body: body === undefined ? undefined : JSON.stringify(body),
    })
    const json = res.status === 204 ? null : await res.json().catch(() => null)
    if (res.ok) return { ok: true, data: json as T | null, errors: [] }
    const errors = Array.isArray(json?.errors) && json.errors.length ? json.errors : ['Something went wrong. Please try again.']
    return { ok: false, data: null, errors }
  } catch {
    return { ok: false, data: null, errors: ['Could not reach the server. Please try again.'] }
  }
}
